export const VARIANTS = [
  // this is all for now!
  'default',
];

export const SIZES = [
  'cta',
  'default',
  'small',
];
